import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function getRawQueryParam(name: string, search?: string): string | null {
    const qs = (search ?? window.location.search).replace(/^\?/, "");
    for (const part of qs.split("&")) {
        const eqIdx = part.indexOf("=");
        if (eqIdx === -1) continue;
        const key = decodeURIComponent(part.slice(0, eqIdx));
        if (key === name) {
            return decodeURIComponent(part.slice(eqIdx + 1));
        }
    }
    return null;
}
